// Pin/unpin functionality for preview popup
import { previewPopupPinned, previewPopupTimeout, setPreviewState, getPreviewState } from './state.js';
import { PREVIEW_POPUP_HIDE_DELAY } from './state.js';

export function createPinButton(pinButton, setPinnedCallback) {
	const updatePinButton = () => {
		const state = getPreviewState();
		if (state.previewPopupPinned) {
			pinButton.addClass('preview-popup__pin--pinned');
			pinButton.attr('aria-label', 'Unpin preview');
			pinButton.attr('title', 'Unpin preview');
			pinButton.find('i').removeClass('bi-pin').addClass('bi-pin-angle-fill');
		} else {
			pinButton.removeClass('preview-popup__pin--pinned');
			pinButton.attr('aria-label', 'Pin preview');
			pinButton.attr('title', 'Pin preview');
			pinButton.find('i').removeClass('bi-pin-angle-fill').addClass('bi-pin');
		}
	};
	
	const setPinned = (pinned) => {
		const state = getPreviewState();
		state.previewPopupPinned = pinned;
		setPreviewState(state);
		updatePinButton();
		if (state.previewPopupPinned && state.previewPopupTimeout) {
			clearTimeout(state.previewPopupTimeout);
			state.previewPopupTimeout = null;
			setPreviewState(state);
		}
		if (setPinnedCallback) {
			setPinnedCallback(pinned);
		}
	};
	
	pinButton.on('click', function(e) {
		e.stopPropagation();
		const state = getPreviewState();
		setPinned(!state.previewPopupPinned);
	});
	
	updatePinButton();
	
	return { setPinned, updatePinButton };
}

export function resetPinButton(pinButton) {
	if (pinButton && pinButton.length > 0) {
		pinButton.removeClass('preview-popup__pin--pinned');
		pinButton.attr('aria-label', 'Pin preview');
		pinButton.attr('title', 'Pin preview');
		pinButton.find('i').removeClass('bi-pin-angle-fill').addClass('bi-pin');
	}
}

export function setupAutoPinHandlers(iframe, previewPopupElement, setPinned) {
	if (iframe.length === 0) return;
	
	// Don't use load.preview-init here - it conflicts with popup.js handler
	// Instead, setup handlers directly without waiting for load
	
	// Always get setPinned from state (it's updated when switching documents)
	// Don't use closure variable setPinned, as it may be stale
	try {
		const iframeWindow = iframe[0].contentWindow;
		const iframeDocument = iframeWindow.document;
		
		$(iframeDocument).on('click.preview-pin', function(e) {
			// Ignore programmatic clicks (isTrusted: false)
			if (!e.isTrusted) return;
			
			const state = getPreviewState();
			const currentSetPinnedFn = state.setPinnedCallback || setPinned;
			if (!state.previewPopupPinned && currentSetPinnedFn) {
				currentSetPinnedFn(true);
			}
		});
		
		$(iframeWindow).on('scroll.preview-pin', function() {
			const state = getPreviewState();
			const currentSetPinnedFn = state.setPinnedCallback || setPinned;
			if (!state.previewPopupPinned && currentSetPinnedFn) {
				currentSetPinnedFn(true);
			}
		});
		
		$(iframeDocument).on('wheel.preview-pin', function() {
			const state = getPreviewState();
			const currentSetPinnedFn = state.setPinnedCallback || setPinned;
			if (!state.previewPopupPinned && currentSetPinnedFn) {
				currentSetPinnedFn(true);
			}
		});
	} catch (e) {
		// Cross-origin - use fallback handlers on iframe element
		iframe.on('click.preview-pin-element', function(e) {
			// Ignore programmatic clicks (isTrusted: false)
			if (!e.isTrusted) return;
			
			const state = getPreviewState();
			const currentSetPinnedFn = state.setPinnedCallback || setPinned;
			if (!state.previewPopupPinned && currentSetPinnedFn) {
				currentSetPinnedFn(true);
			}
		});
		
		iframe.on('wheel.preview-pin', function() {
			const state = getPreviewState();
			const currentSetPinnedFn = state.setPinnedCallback || setPinned;
			if (!state.previewPopupPinned && currentSetPinnedFn) {
				currentSetPinnedFn(true);
			}
		});
	}
	
	previewPopupElement.find('.preview-popup__content').on('click.preview-pin', function(e) {
		// Ignore programmatic clicks (isTrusted: false)
		if (!e.isTrusted) return;
		
		if (e.target === this || $(e.target).hasClass('preview-popup__loading')) {
			const state = getPreviewState();
			const currentSetPinnedFn = state.setPinnedCallback || setPinned;
			if (!state.previewPopupPinned && currentSetPinnedFn) {
				currentSetPinnedFn(true);
			}
		}
	});
}

export function cleanupAutoPinHandlers(iframe, previewPopupElement) {
	if (iframe.length > 0) {
		try {
			const iframeWindow = iframe[0].contentWindow;
			const iframeDocument = iframeWindow.document;
			$(iframeDocument).off('click.preview-pin wheel.preview-pin');
			$(iframeWindow).off('scroll.preview-pin');
		} catch (e) {
			// Cross-origin - ignore
		}
		iframe.off('click.preview-pin-element wheel.preview-pin click.preview-pdf-pin-element mousedown.preview-pdf-pin-element wheel.preview-pdf-pin load.preview-pdf-pin');
	}
	previewPopupElement.find('.preview-popup__content').off('click.preview-pin click.preview-pdf-pin mousedown.preview-pdf-pin');
}

